<template>
    <!-- Employee Edit Function For Company Admin -->
    <div>
        <div class="tabs-content-secondblock mb-7">
            <div class="row" v-if="ajaxCallinprogress">
                <div class="col-lg-12 py-5 px-3 mt-10">
                    <div class="flex-container">
                        <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
                    </div>
                </div>
            </div>
            <div class="row" v-if="!ajaxCallinprogress">
                <div class="col-lg-12">
                    <div class="infoHeader ml-2 mr-1">
                        <div class="descriptionheader">
                            <div class="description-text-header-left">
                                <h5>
                                    <i class="crmnew-basic iconsize-16 pr-1 defaultBlue"></i>
                                    Basic Information
                                </h5>
                            </div>
                            <div class="description-text-header-right">
                                <button class="btn btn-white btn-smm btn-no-border-blue ml-3"
                                    style="color: #00448b;background-color: transparent; box-shadow: none !important;min-width: 5rem;"
                                    @click="hideEdit">CANCEL</button>
                                <button type="button" @click="EditEmployee" class="btn btn-secondary btn-smm ml-3"
                                    style="box-shadow: none;" v-if="!requestResponse">SAVE</button>
                                <button type="button" class="btn btn-secondary btn-smm ml-3 disabledbutton"
                                    style="box-shadow: none;" v-else>SAVE</button>
                            </div>
                        </div>
                    </div>
                    <div class="ml-2 mr-1">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="a-q-Jc-j-editBusinessView mt-1">
                                    <div class="a-q-Jc-Pj-Ya-editBusinessView">
                                        <div class="a-q-Jc-bj-editBusinessView defaultBlue mt-3">
                                            First Name
                                            <sup class="fs-14 ml-1 mandatory">*</sup>
                                        </div>
                                        <div class="a-q-Jc-Lb-editBusinessView">
                                            <span class="a-q-Jc-wg-editBusinessView font-color">
                                                <input class="inputField" type="text" data-vv-scope="employeeInfo"
                                                    data-vv-as="First Name" name="first_name"
                                                    :maxlength="maxlengthemployeefirstname"
                                                    v-model="editBusinessData.first_name.value" v-validate="'required'"
                                                    placeholder="Enter First Name" style="text-transform:capitalize" />
                                                <span
                                                    class="editcharacter-count text-grey">{{maxlengthemployeefirstname - editBusinessData.first_name.value.length}}/20</span>
                                                <span class="invalid-feedback-form text-danger mt-4"
                                                    style="text-transform: none !important;"
                                                    v-show="errors.has('employeeInfo.first_name')">{{errors.first('employeeInfo.first_name')}}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-editBusinessView">
                                    <div class="a-q-Jc-Pj-Ya-editBusinessView">
                                        <div class="a-q-Jc-bj-editBusinessView defaultBlue mt-3">Middle Name</div>
                                        <div class="a-q-Jc-Lb-editBusinessView">
                                            <span class="a-q-Jc-wg-editBusinessView text-runcate">
                                                <input class="inputField" type="text"
                                                    v-model="editBusinessData.middle_name.value"
                                                    placeholder="Enter Middle Name" style="text-transform:capitalize" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-editBusinessView">
                                    <div class="a-q-Jc-Pj-Ya-editBusinessView">
                                        <div class="a-q-Jc-bj-editBusinessView defaultBlue mt-3">
                                            Last Name
                                            <sup class="fs-14 ml-1 mandatory">*</sup>
                                        </div>
                                        <div class="a-q-Jc-Lb-editBusinessView">
                                            <span class="a-q-Jc-wg-editBusinessView">
                                                <input class="inputField" type="text" name="last_name"
                                                    data-vv-scope="employeeInfo" data-vv-as="Last Name"
                                                    :maxlength="maxlengthemployeelastname"
                                                    v-model="editBusinessData.last_name.value" v-validate="'required'"
                                                    placeholder="Enter Last Name" style="text-transform:capitalize" />
                                                <span
                                                    class="editcharacter-count text-grey">{{maxlengthemployeelastname - editBusinessData.last_name.value.length}}/20</span>
                                                <span class="invalid-feedback-form text-danger mt-4"
                                                    style="text-transform: none !important;"
                                                    v-show="errors.has('employeeInfo.last_name')">{{errors.first('employeeInfo.last_name')}}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-editBusinessView"
                                    v-if="editBusinessData.gender.value === 'Male' || editBusinessData.gender.value === 'Female'">
                                    <div class="a-q-Jc-Pj-Ya-editBusinessView">
                                        <div class="a-q-Jc-bj-editBusinessView defaultBlue mt-4">
                                            Gender
                                            <sup class="fs-14 ml-1 mandatory">*</sup>
                                        </div>
                                        <div class="a-q-Jc-Lb-editBusinessView pb-3">
                                            <span class="a-q-Jc-wg-editBusinessView">
                                                <div class="preview-elements previewElementsContacts radiooptions mt-3">
                                                    <div class="form-check form-check-inline gender-radio">
                                                        <label class="form-check-label check-label-dc">
                                                            <input class="form-check-input" type="radio"
                                                                v-model="editBusinessData.gender.value" name="gender"
                                                                value="Male" />
                                                            <span class="radio-icon"></span>
                                                            <span class="form-check-description fw-600">Male</span>
                                                        </label>
                                                    </div>
                                                    <div class="form-check form-check-inline gender-radio">
                                                        <label class="form-check-label check-label-dc"
                                                            style="width: 63px;">
                                                            <input class="form-check-input" type="radio"
                                                                v-model="editBusinessData.gender.value" name="gender"
                                                                value="Female" />
                                                            <span class="radio-icon"></span>
                                                            <span class="form-check-description fw-600">Female</span>
                                                        </label>
                                                    </div>
                                                    <div class="form-check form-check-inline gender-radio">
                                                        <label class="form-check-label check-label-dc">
                                                            <input class="form-check-input" type="radio"
                                                                v-model="editBusinessData.gender.value" name="gender"
                                                                value="" />
                                                            <span class="radio-icon"></span>
                                                            <span class="form-check-description fw-600">Custom</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="a-q-Jc-Pj-Ya-editBusinessView">
                                        <div class="a-q-Jc-bj-editBusinessView defaultBlue mt-4">
                                            Gender
                                            <sup class="fs-14 ml-1 mandatory">*</sup>
                                        </div>
                                        <div class="a-q-Jc-Lb-editBusinessView pb-3">
                                            <span class="a-q-Jc-wg-editBusinessView">
                                                <div class="preview-elements previewElementsContacts radiooptions mt-3">
                                                    <div class="form-check form-check-inline gender-radio">
                                                        <label class="form-check-label check-label-dc">
                                                            <input class="form-check-input" type="radio"
                                                                :checked="editBusinessData.gender.value != 'Male' || editBusinessData.gender.value != 'female'" />
                                                            <span class="radio-icon"></span>
                                                            <span
                                                                class="form-check-description d-flex align-items-center fw-600">
                                                                Custom
                                                                <div class="d-flex">
                                                                    <input
                                                                        v-if="editBusinessData.gender.value != 'Male' || editBusinessData.gender.value != 'female'"
                                                                        name="gender" v-validate="'required'"
                                                                        type="text"
                                                                        v-model="editBusinessData.gender.value"
                                                                        style="margin-left: 10px; border-bottom: 1px solid; background: transparent; padding-right: 15px;">
                                                                    <span
                                                                        v-if="editBusinessData.gender.value != 'Male' || editBusinessData.gender.value != 'female'"
                                                                        @click.prevent="editBusinessData.gender.value = 'Male'"
                                                                        style="cursor: pointer; margin-left: -10px;">
                                                                        <img src="/static/images/cross.svg"
                                                                            height="8px">
                                                                    </span>
                                                                </div>
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-editBusinessView">
                                    <div class="a-q-Jc-Pj-Ya-editBusinessView">
                                        <div class="a-q-Jc-bj-editBusinessView defaultBlue mt-2">
                                            Date of Birth
                                            <br />(dd/mm/yyyy)
                                        </div>
                                        <div class="a-q-Jc-Lb-editBusinessView mt-2">
                                            <span class="a-q-Jc-wg-editBusinessView">
                                                <date-picker v-model="editBusinessData.date_of_birth.value"
                                                    :first-day-of-week="7" :not-after="new Date()"
                                                    data-vv-scope="employeeInfo" data-vv-as="Date Of Birth"
                                                    name="date_of_birth"
                                                    class="calendarYear mx-left calendar-edit-per mx-left"
                                                    format="DD/MM/YYYY" lang="en" :clearable="false" :editable="false"
                                                    confirm confirm-text="APPLY" @confirm="$forceUpdate()">
                                                </date-picker>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="a-q-Jc-j-editBusinessView">
                  <div class="a-q-Jc-Pj-Ya-editBusinessView">
                    <div class="a-q-Jc-bj-editBusinessView defaultBlue mt-3">
                      Personal Email
                      <sup class="fs-14 ml-1 mandatory">*</sup>
                    </div>
                    <div class="a-q-Jc-Lb-editBusinessView">
                      <span class="a-q-Jc-wg-editBusinessView">
                        <input
                          class="inputField"
                          name="email"
                          :disabled="true"
                          v-model="editBusinessData.user.primary_email.value"
                          type="email"
                        />
                      </span>
                    </div>
                  </div>
                </div> -->

                                <div class="a-q-Jc-j-editBusinessView">
                                    <div class="a-q-Jc-Pj-Ya-editBusinessView">
                                        <div class="a-q-Jc-bj-editBusinessView defaultBlue mt-3">
                                            Business Email
                                            <sup class="fs-14 ml-1 mandatory">*</sup>
                                        </div>
                                        <div class="a-q-Jc-Lb-editBusinessView">
                                            <span class="a-q-Jc-wg-editBusinessView">
                                                <input class="inputField" name="businessemail" :disabled="true"
                                                    v-model="editBusinessData.primary_email.value"
                                                    placeholder="Enter Business Email" type="email" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-editBusinessView">
                                    <div class="a-q-Jc-Pj-Ya-editBusinessView">
                                        <div class="a-q-Jc-bj-editBusinessView defaultBlue mt-3">
                                            Phone Number
                                            <sup class="fs-14 ml-1 mandatory">*</sup>
                                        </div>
                                        <div class="a-q-Jc-Lb-editBusinessView">
                                            <span class="a-q-Jc-wg-editBusinessView">
                                                <vue-tel-input class="teleContact mt-2" name="phone_number"
                                                    v-model="editBusinessData.primary_phone.value.phone_number"
                                                    v-on:country-changed="countryChanged($event, 'employee_phone', 0)"
                                                    ref="telInput" placeholder="Enter Phone Number"
                                                    :disabledFormatting="false" :valid-characters-only="true"
                                                    v-validate="{required:true,min:13}" data-vv-scope="employeeInfo"
                                                    data-vv-as="Phone Number" :maxLen="maxPhoneLength"
                                                    autocomplete="off"
                                                    onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                                                    @input="$validator.validate('employeeInfo.phone_number')">
                                                </vue-tel-input>
                                                <span class="invalid-feedback-form text-danger"
                                                    style="text-transform: none !important;"
                                                    v-show="errors.has('employeeInfo.phone_number')">{{errors.first('employeeInfo.phone_number')}}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-editBusinessView">
                                    <div class="a-q-Jc-Pj-Ya-editBusinessView">
                                        <div class="a-q-Jc-bj-editBusinessView defaultBlue mt-3">Blood Group</div>
                                        <div class="a-q-Jc-Lb-editBusinessView">
                                            <span class="a-q-Jc-wg-editBusinessView">
                                                <v-select class="vselect-custom vselect-bloodgroup"
                                                    placeholder="Select Blood Group"
                                                    v-model="editBusinessData.health.value.blood_group"
                                                    :options="bloodgroup" data-vv-scope="userData"
                                                    data-vv-as="Blood Group" style="width: 100%;margin-top: 7px;"
                                                    name="bloodgroup"></v-select>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-editBusinessView mt-3">
                                    <div class="a-q-Jc-Pj-Ya-editBusinessView">
                                        <div class="a-q-Jc-bj-editBusinessView defaultBlue">
                                            User Access
                                            <sup class="fs-14 ml-02 mandatory">*</sup>
                                        </div>
                                        <div class="a-q-Jc-Lb-editBusinessView">
                                            <span class="a-q-Jc-wg-editBusinessView">
                                                <div class="form-check form-check-inline user-perm">
                                                    <label class="form-check-label check-label-dc">
                                                        <input class="form-check-input" type="radio" v-bind:value="true"
                                                            v-model="editBusinessData.is_admin" @click="onToggleAdmin()"
                                                            name="useraccess" />
                                                        <span class="radio-icon"></span>
                                                        <span class="form-check-description fw-600">Admin</span>
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline user-perm">
                                                    <label class="form-check-label check-label-dc">
                                                        <input class="form-check-input" type="radio" v-bind:value="true"
                                                            v-model="editBusinessData.is_superadmin"
                                                            @click="onToggleIsAdmin()" name="useraccess" />
                                                        <span class="radio-icon"></span>
                                                        <span class="form-check-description fw-600">Super Admin</span>
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline user-perm">
                                                    <label class="form-check-label check-label-dc">
                                                        <input class="form-check-input" type="radio" v-bind:value="true"
                                                            v-model="editBusinessData.is_user" @click="onToggleUser()"
                                                            name="useraccess" />
                                                        <span class="radio-icon"></span>
                                                        <span class="form-check-description fw-600">User</span>
                                                    </label>
                                                </div>
                                                <!-- <span class="invalid-feedback-form text-danger" v-show="errors.has('userData.useraccess')">{{errors.first('userData.useraccess')}}</span> -->
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-editBusinessView">
                                    <div class="a-q-Jc-Pj-Ya-editBusinessView">
                                        <div class="a-q-Jc-bj-editBusinessView defaultBlue mt-3">Reporting Manager</div>
                                        <div class="a-q-Jc-Lb-editBusinessView">
                                            <span class="a-q-Jc-wg-editBusinessView">
                                                <multiselect class="digi-multiselect loaderbg"
                                                    placeholder="Select Reporting Manager" :clearable="false"
                                                    :filterable="true" @open="getReportingManager"
                                                    @search-change="getReportingManager" @select="$forceUpdate()"
                                                    v-model="editBusinessData.reporting_manager"
                                                    :options="reporting_managers" :loading="isLoading.reporting_manager"
                                                    data-vv-scope="userData" data-vv-as="Reporting Manager"
                                                    label="full_name" track_by="_id" :show-labels="false"
                                                    style="width: 100%;margin-top: 7px;" name="reportingManager">
                                                </multiselect>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-editBusinessView mt-1">
                                    <div class="a-q-Jc-Pj-Ya-editBusinessView">
                                        <div class="a-q-Jc-bj-editBusinessView defaultBlue mt-3">Signature Name</div>
                                        <div class="a-q-Jc-Lb-editBusinessView">
                                            <span class="a-q-Jc-wg-editBusinessView font-color">
                                                <input class="inputField" type="text" data-vv-scope="employeeInfo"
                                                    data-vv-as="Signature Name" name="signature_name"
                                                    :maxlength="maxlengthemployeefirstname"
                                                    v-model="editBusinessData.signature.name"
                                                    placeholder="Enter Signature Name" />
                                                <span
                                                    class="editcharacter-count text-grey">{{maxlengthemployeefirstname - editBusinessData.signature.name.length}}/20</span>
                                                <span class="invalid-feedback-form text-danger"
                                                    style="text-transform: none !important;"
                                                    v-show="errors.has('employeeInfo.signature_name')">{{errors.first('employeeInfo.signature_name')}}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="a-q-Jc-j-editBusinessView mt-1">
                                    <div class="a-q-Jc-Pj-Ya-editBusinessView">
                                        <div class="a-q-Jc-bj-editBusinessView defaultBlue mt-3">Signature</div>
                                        <div class="a-q-Jc-Lb-editBusinessView">
                                            <div class="attachment-bg pb-4 mt-5" style="border: 0 !important">
                                                <div class="upload-main d-flex justify-content-center mt-4"
                                                    v-if="attachments.length == 0">
                                                    <div class="img-upload pl-15 pr-15 pt-3 pb-3 text-center"
                                                        style="border: 0 !important">
                                                        <label class="choose-file btn mt-1" style="color: #cbcbcb">
                                                            <input class="d-none" type="file" id="multiple" multiple
                                                                @change="uploadAttachment" accept="image/*" />
                                                            Click Here To Upload Signature
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="d-flex flex-wrap align-items-center mt-4">
                                                    <div class="col-lg-12 col-md-12 col-sm-12"
                                                        v-for="(attachment,index) in attachments" :key="index">
                                                        <div class="d-flex align-items-center mt-6 pr-6">
                                                            <div class="d-flex align-items-center" style="width:90%">
                                                                <div>
                                                                    <img v-if="attachment.name.endsWith('.pdf')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                                                    <img v-else-if="attachment.name.endsWith('.png')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg" />
                                                                    <img v-else-if="attachment.name.endsWith('.jpg')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg" />
                                                                    <img v-else-if="attachment.name.endsWith('.svg')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                                                    <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                                                    <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                                                </div>
                                                                <div class="col">
                                                                    <div class="d-flex justify-content-between">
                                                                        <el-tooltip :content="attachment.name"
                                                                            placement="top">
                                                                            <div
                                                                                class="font-weight-bold text-truncate d-block mx-width-220">
                                                                                {{attachment.name}}</div>
                                                                        </el-tooltip>
                                                                    </div>
                                                                    <div
                                                                        v-if="attachment.uploading || attachment.url == undefined">
                                                                        <progress-bar class="progressBar w-100"
                                                                            :class="{'error-upload':attachment.url == undefined}"
                                                                            :val="attachment.progress" size="small">
                                                                        </progress-bar>
                                                                    </div>
                                                                    <div class="d-flex justify-content-between">
                                                                        <div class="text-danger pl-0 fw-500"
                                                                            v-if="attachment.error != ''">
                                                                            {{attachment.error}}...</div>
                                                                        <div class="text-secondary fw-500"
                                                                            v-if="attachment.progress<100 && attachment.error == ''">
                                                                            {{attachment.progress}}% Uploaded</div>
                                                                        <div class="fw-500">
                                                                            ({{attachment.size | prettyBytes}})</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="pointer" style="width:10%"
                                                                @click="deleteAttachment(attachment,index)">
                                                                <i class="icon icon-close fs-16 closeAttachment"
                                                                    v-if="attachment.uploading || attachment.url == undefined"></i>
                                                                <i class="icon icon-trash text-secondary fs-20"
                                                                    v-if="attachment.url && attachment.uploading == false"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        EventBus
    } from "./eventBus/nav-bar-event.js";
    import VueTelInput from "vue-tel-input";

    import bloodgroup from "./json/bloodgroup.json";
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import uploadSignature from "./mixins/uploadSignature";
    export default {
        data() {
            return {
                employeeInfo: {
                    first_name: "",
                    middle_name: "",
                    last_name: "",
                    primary_email: "",
                    // blood_group: "",
                    primary_phone: {
                        phone_number: "",
                        country_code: "",
                        dial_code: "",
                    },
                    gender: "",
                    custom_gender: {
                        gender: "",
                        preposition: "",
                    },
                    is_admin: false,
                    is_superadmin: false,
                },
                is_user: false,
                products: [],
                EmailExists: false,
                permission_dict: {},
                access_given: {},
                update_access: {},
                remove_access: {},
                maxPhoneLength: 15,
                maxlengthemployeefirstname: 20,
                maxlengthemployeelastname: 20,
                bloodgroup: bloodgroup,
                ajaxCallinprogress: false,
                requestResponse: false,
                editBusinessData: {},
                country: null,
                attachments: [],
                reporting_managers: [],
                isLoading: {
                    reporting_manager: false,
                },
            };
        },
        mixins: [uploadSignature],
        components: {
            VueTelInput,
            HalfCircleSpinner,
        },
        methods: {
            deleteAttachment(attachment, index) {
                this.attachments.splice(index, 1);
                document.getElementById("multiple").value = "";
                if (attachment.url == undefined) {
                    this.check_attachments = false;
                }
            },
            countryChanged(country, variable, index) {
                switch (variable) {
                    case "employee_phone":
                        this.editBusinessData.primary_phone.value.dial_code = country.dialCode;
                        this.editBusinessData.primary_phone.value.country_code = country.iso2;
                        break;
                }
            },
            // Admin and SuperAdmin Toggling
            onToggleIsAdmin() {
                this.editBusinessData.is_superadmin = true;
                this.editBusinessData.is_admin = false;
                this.editBusinessData.is_user = false;
            },
            onToggleAdmin() {
                this.editBusinessData.is_admin = true;
                this.editBusinessData.is_superadmin = false;
                this.editBusinessData.is_user = false;
            },
            onToggleUser() {
                this.editBusinessData.is_admin = false;
                this.editBusinessData.is_superadmin = false;
                this.editBusinessData.is_user = true;
            },

            updateEmployeeBasic() {
                // this.saveEditUser(this.editPersonalData);
                // this.$emit('updateUserData');
            },
            // Deactivate Edit Mode
            hideEdit() {
                let data = this.employeeInfo;
                this.$emit("deactivateEditMode", data);
            },

            // Edit Employee Save Function
            EditEmployee() {
                this.$validator.validateAll("employeeInfo").then(result => {
                    if (result && !this.EmailExists) {
                        if (this.attachments.length) {
                            this.editBusinessData.signature.signature_url = this.attachments[0].url;
                            this.editBusinessData.signature.size = Number(this.attachments[0].size);
                        } else {
                            this.editBusinessData.signature.signature_url = "";
                            this.editBusinessData.signature.size = 0;
                        };
                        if ("is_user" in this.editBusinessData) {
                            delete this.editBusinessData["is_user"];
                        };
                        if (this.editBusinessData.reporting_manager._id == "") {
                            delete this.editBusinessData["reporting_manager"];
                        } else {
                            this.editBusinessData.reporting_manager = {
                                _id: this.editBusinessData.reporting_manager._id,
                                full_name: this.editBusinessData.reporting_manager.full_name,
                            };
                        }
                        this.requestResponse = true;
                        this.$http
                            .post("/employees/edit_employee", {
                                emp_data: this.editBusinessData,
                            })
                            .then(res => {
                                if (res.data.status_id == 1) {
                                    this.requestResponse = false;
                                    let data = this.editBusinessData;
                                    this.$emit("deactivateEditMode", data);
                                    this.$swal({
                                        title: "Success!",
                                        text: "Successfully Edited Your Information",
                                        type: "success",
                                        confirmButtonText: "OK",
                                        confirmButtonColor: "#005dae",
                                    });
                                } else {
                                    this.requestResponse = false;
                                    this.$swal({
                                        title: "Error!",
                                        html: "Not Able to Edit Employee. Please Contact " +
                                            '<a href="mailto:helpdesk@digicollect.com" style="color: #00448b">DigiCollect Helpdesk</a>',
                                        type: "error",
                                        confirmButtonText: "OK",
                                        confirmButtonColor: "#005dae",
                                    });
                                }
                            });
                    }
                });
            },

            // EditEmployee() {
            //       this.$validator.validateAll("employeeInfo").then(result => {
            //       if (result && !this.EmailExists) {
            //         this.editEmployee();
            //         let data = this.employeeInfo
            //         this.$emit('deactivateEditMode', data)
            //       }
            //     })
            // },

            // Check Primary Email
            checkEmail() {
                this.$http
                    .post("/users/check_primary_email", {
                        email_id: this.editBusinessData.email_id,
                    })
                    .then(response => {
                        this.EmailExists = response.data.status_id;
                    })
                    .catch(error => {});
            },

            // Getting Employees
            getEmployeeData() {
                this.ajaxCallinprogress = true;
                this.$http
                    .post("employees/get_employee_data", {
                        emp_id: this.$route.params.id,
                        company_id: this.$route.params.id
                    })
                    .then(response => {
                        if (response.data.status_id == 1) {
                            this.employeeInfo = response.data.response;
                            this.editBusinessData = JSON.parse(
                                JSON.stringify(this.employeeInfo)
                            );
                            if (!("middle_name" in this.editBusinessData)) {
                                Object.assign(this.editBusinessData, {
                                    middle_name: {
                                        value: "",
                                        privacy: "contacts",
                                    }
                                });
                            }
                            if (!("last_name" in this.editBusinessData)) {
                                Object.assign(this.editBusinessData, {
                                    last_name: {
                                        value: "",
                                        privacy: "contacts",
                                    }
                                });
                            }
                            if (!("gender" in this.editBusinessData)) {
                                Object.assign(this.editBusinessData, {
                                    gender: {
                                        value: "Male",
                                        privacy: "contacts",
                                    }
                                });
                            } else if ("gender" in this.editBusinessData && !this.editBusinessData.gender.value) {
                                this.editBusinessData.gender.value = "Male";
                            }
                            if (!("custom_gender" in this.editBusinessData)) {
                                Object.assign(this.editBusinessData, {
                                    custom_gender: {
                                        preposition: "",
                                        gender: "",
                                    }
                                });
                            }
                            if (!("date_of_birth" in this.editBusinessData)) {
                                Object.assign(this.editBusinessData, {
                                    date_of_birth: {
                                        value: "",
                                        privacy: "contacts",
                                    }
                                });
                            }
                            if (!("health" in this.editBusinessData)) {
                                Object.assign(this.editBusinessData, {
                                    health: {
                                        value: {
                                            blood_group: "",
                                            pre_existing_conditions: [],
                                            allergies: [],
                                            medications: [],
                                            notes: "",
                                        },
                                        privacy: "contacts",
                                    },
                                });
                            }
                            if (!("primary_phone" in this.editBusinessData)) {
                                Object.assign(this.editBusinessData, {
                                    primary_phone: {
                                        privacy: "contacts",
                                        value: {
                                            country_code: "",
                                            dial_code: "",
                                            phone_number: "",
                                            phone_type: "",
                                        },
                                        verified: false,
                                    }
                                });
                            }
                            if (!this.editBusinessData.is_admin && !this.editBusinessData.is_superadmin) {
                                Object.assign(this.editBusinessData, {
                                    is_user: true,
                                });
                            }
                            if (!this.editBusinessData.hasOwnProperty("reporting_manager")) {
                                Object.assign(this.editBusinessData, {
                                    reporting_manager: {
                                        _id: "",
                                        full_name: "",
                                    }
                                });
                            }
                            if (!("signature" in this.editBusinessData)) {
                                Object.assign(this.editBusinessData, {
                                    signature: {
                                        name: "",
                                        signature_url: "",
                                        size: "",
                                    },
                                });
                            } else if (this.editBusinessData.signature.name == "") {
                                this.editBusinessData.signature.signature_url = "";
                                this.editBusinessData.signature.size = "";
                            } else if (this.editBusinessData.signature.name && this.editBusinessData.signature
                                .signature_url && this.editBusinessData.signature.size) {
                                this.attachments.push({
                                    name: this.editBusinessData.signature.name + '.jpg',
                                    url: this.editBusinessData.signature.signature_url,
                                    size: this.editBusinessData.signature.size,
                                    uploading: false,
                                });
                            }
                            this.ajaxCallinprogress = false;
                        }
                    })
                    .catch(error => {
                    });
            },
            async getReportingManager(key) {
                this.isLoading.reporting_manager = true;
                let params = {
                    search_key: "",
                    skip: 0,
                    limit: 10,
                    company_id: this.selectedCompany._id,
                    active_status: "active",
                };
                if (key) {
                    params.search_key = key;
                }
                let res = await this.$http.post("/employees/get_employees", params);
                if (res.data.status_id == 1) {
                    this.reporting_managers = res.data.response;
                    this.isLoading.reporting_manager = false;
                }
            }
        },
        created() {
            const dict = {
                custom: {
                    first_name: {
                        required: () => "First Name is Required",
                    },
                    last_name: {
                        required: () => "Last Name is Required",
                    },
                    phone_number: {
                        required: () => "Phone Number is Required",
                        min: () => "Phone Number must Contain more than 9 Numbers",
                    },
                },
            };
            this.$validator.localize("en", dict);
            this.getEmployeeData();
        },
        computed: {
            account() {
                return this.$store.getters.account;
            },
            selectedCompany() {
                return this.$store.getters.selectedCompany;
            },
        },
    };
</script>
<style>
    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content .el-tab-pane .tabs-content-firstblock {
        border-radius: 5px;
        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px #cdd2da;
        background-color: #ffffff;
        margin: 5px 10px 15px;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content .el-tab-pane .tabs-content-secondblock {
        border-radius: 5px;
        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px #cdd2da;
        background-color: #ffffff;
        margin: 5px 10px 15px;
    }

    textarea.textarea-control {
        height: auto;
    }

    textarea.textarea-control {
        display: block;
        width: 100%;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857143;
        color: #4e5764;
        background-color: #fff;
        background-image: none;
        border: 1px solid #cdd2da;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        -webkit-transition: border-color ease-in-out 0.15s,
            box-shadow ease-in-out 0.15s;
        -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
        -webkit-transition: border-color ease-in-out 0.15s,
            -webkit-box-shadow ease-in-out 0.15s;
        transition: border-color ease-in-out 0.15s,
            -webkit-box-shadow ease-in-out 0.15s;
        transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
        transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s,
            -webkit-box-shadow ease-in-out 0.15s;
    }

    .input-group.digi-input-group {
        border: 1px solid #cdd2da !important;
    }

    .input-group.digi-input-group>.form-control {
        position: relative !important;
        -webkit-box-flex: 1 !important;
        -webkit-flex: 1 1 auto !important;
        -ms-flex: 1 1 auto !important;
        flex: 1 1 auto !important;
        width: 1% !important;
        margin-bottom: 0 !important;
        height: 22px !important;
        padding: 6px 12px 6px 2px !important;
        color: #4e5764;
        text-decoration: underline;
        border-bottom: 1px solid transparent !important;
    }

    .input-group.digi-input-group .input-group-addon {
        padding-left: 0rem !important;
        padding-right: 0.2rem !important;
        border-bottom: 1px solid transparent !important;
        padding-top: 2px;
        cursor: pointer;
    }

    .qrcode-block-view-account {
        border-radius: 6px;
        width: 104px;
        height: 105px;
        position: relative;
        display: inline-block;
        display: block;
        border: 1px solid #00448b;
        background: #d6e2ef;
    }

    .qrcode-content-view-account {
        text-align: center;
        margin: 6px auto;
        background: #d6e2ef !important;
    }

    .qr-logo-view-account {
        position: absolute;
        margin-top: 40px;
        margin-left: 35px;
        width: 30px;
    }

    .grey-border-box {
        border: dashed 0px transparent;
        padding: 11px 20px;
        font-size: 13px;
        font-weight: 600;
        line-height: 1.92;
        letter-spacing: 0.56px;
        text-align: center;
        color: #00448b;
        width: 265px;
        margin: 0 auto;
        border-radius: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/components/EditEmployeeBasicView.vue